<template>
  <div>
    <Head title="Sorting" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/sort-receipts">Sorting Receipts</Link>
      <span class="text-orange-400 font-medium">/</span> Create
    </h1>
    <div v-if="components.length > 0" class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div
          v-for="component in componentsData"
          :key="component.id"
          class="flex flex-wrap -mb-8 -mr-6 p-8"
        >
          <text-input 
            v-model="component.value"
            class="pb-8 pr-6 w-1/2 lg:w-1/2"
            :label="component.name"
            :value="component.value"
          />
          <div class="pb-2 pr-6 w-full lg:w-1/2">
            <p class="p-1">Destination</p>
            <select-input
              v-model="component.destination"
              :error="form.errors.location"
              class="pb-2 pr-6 w-full lg:w-full"
            >
              <option :value="Silos">
                Silos
              </option>
              <option
                v-for="destination in destinations"
                :key="destination"
                :value="destination"
              >
                {{ destination }}
              </option>
            </select-input>
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Save</loading-button>
        </div>
      </form>
    </div>
    <div v-else class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <p class="p-5">No components defined for this SKU.</p>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
// import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    // FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    components: Object,
    itemObj: Object,
    destinations: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        componentData: {
          id: null,
          name: null,
          value: null,
          destination: null,
        },
      }),
    }
  },
  computed: {
    componentsData() {
      const typesObj = []
      this.components.forEach((item) => {
        typesObj.push({
          id: item.id, name: item.name, value: 0, destination: 'Silos'
        })
      })
      return typesObj || []
    },
  },
  methods: {
    store() {
      this.form.componentData = this.componentsData
      this.form.post(`/sorting-receipts/${this.itemObj.id}/store`)
    },
  },
}
</script>
